<div class='width-600'>

  <mat-card>
    <div class='img-box'>
      <img src="assets/images/geral/logo_azul.png">
    </div>
  </mat-card>

  <mat-card style="text-align: center; font-size: 1.5em;">
    ANUIDADES SBCCV
  </mat-card>

  <mat-card style="text-align: center;">
    <div>
      {{member_name}}
    </div>
    <div>
      {{category_name}}
    </div>
  </mat-card>

  <div *ngIf="!letter_datePayed && !error">

    <div *ngIf="type == 'Pix'"> <!--ASSAS-->

      <mat-card>
        <div *ngIf="qrCodeImage" class="qrcode-image-wrapper">
          <img [src]="qrCodeImage">
        </div>
      </mat-card>

      <mat-card>
        <div class="qrcode-wrapper">
          <a mat-button color="primary" (click)="copyToClipboard(qrCode)">
            <mat-icon>content_copy</mat-icon>
            Copiar Código PIX
          </a>
        </div>
      </mat-card>

    </div>

    <div *ngIf="type == 'BOLETO'"> <!--ASSAS-->

      <mat-card>
        <div *ngIf="bankSlipUrl" class="bankSlipUrl">
          <a matTooltip="Visualizar" target='_blank' href={{bankSlipUrl}}>
            Clique aqui para baixar o boleto
          </a>
        </div>
      </mat-card>


      <mat-card>
        <div *ngIf="identificationField" class="identificationField">
          {{identificationField}}
        </div>
      </mat-card>

      <mat-card>
        <div class="qrcode-wrapper">
          <a mat-button color="primary" (click)="copyToClipboard(identificationField)">
            <mat-icon>content_copy</mat-icon>
            Copiar Linha digitável
          </a>
        </div>
      </mat-card>

    </div>

    <div *ngIf="type == 'CREDIT_CARD'"> <!--ASSAS-->

      <mat-card style="height: 260px;">
        <div class="credit-card-authorized">
          Pagamento Autorizado.
        </div>
      </mat-card>

    </div>

    <div *ngIf="type == 'CreditCard'"> <!--CIELO-->

      <mat-card style="height: 260px;">
        <div class="credit-card-authorized">
          Pagamento Autorizado.
        </div>
      </mat-card>

    </div>
  </div>

  <div *ngIf="letter_datePayed && !error">

    <mat-card style="height: 260px;">
      <div class="letter-payed">
        Pagamento Recebido.
      </div>
      <div class="letter-payed">
        Obrigado.
      </div>

      <div style="text-align: center;">
        <br><br>
        <button mat-raised-button (click)='gotoInvoiceAndReceipt()'>
          <div class="letter-payed">Recibo</div>
        </button>
      </div>

    </mat-card>

  </div>

  <div *ngIf="error">

    <mat-card *ngIf="error" style="height: 260px;">
      <div class="error-text">
        Erro ao processar pagamento.
      </div>
      <div class="error-button">
        <button mat-raised-button (click)="goBack()">
          <span style="color: blue">
            Voltar
          </span>
        </button>
      </div>
    </mat-card>
  </div>

</div>

<br>
<br>